import React, { useState, memo } from 'react'
import SearchHeader from '../../lib/react-storefront/search/SearchHeader'
import SearchForm from '../../lib/react-storefront/search/SearchForm'
import SearchField from '../../lib/react-storefront/search/SearchField'
import SearchDrawer from '../../lib/react-storefront/search/SearchDrawer'
import SearchButton from '../../lib/react-storefront/search/SearchButton'
import SearchProvider from '../../providers/SearchProvider'
import { useRouter } from 'next/router'
import SearchSuggestions from './searchComponents/SearchSuggestions'

function SearchMobile() {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [query, setQuery] = useState('')
  const [input, setInput] = useState('')
  const toggleDrawer = () => setDrawerOpen(!drawerOpen)
  const closeDrawer = () => setDrawerOpen(false)
  const router = useRouter()
  let { storeSlug } = router.query
  return (
    <>
      <SearchButton onClick={toggleDrawer} />
      <SearchDrawer open={drawerOpen} onClose={closeDrawer}>
        <SearchForm action={'/store/' + storeSlug + '/search'}>
          <SearchHeader>
            <SearchField
              onChange={value => {
                let v = value.replace(/[\/\\#+^()$~%:*?<>{}@!]/g, '')
                setQuery(v)
                setInput(v)
              }}
              value={input}
            />
          </SearchHeader>
          <SearchProvider store={storeSlug} query={query} active={drawerOpen}>
            <SearchSuggestions classes={{ root: '', group: 'mob-formatting' }} />
          </SearchProvider>
        </SearchForm>
      </SearchDrawer>
    </>
  )
}

export default memo(SearchMobile)